import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const searchUsers = createApiThunk<User[], UserSearchPayload>({
  action: 'users/search',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_USERS,
  getParams: (payload) => payload,
})

export const searchPrivilegeUsers = createApiThunk<PrivilegeUserSearchResponse, PrivilegeUserSearchPayload>({
  action: 'users/privileges',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_PRIVILEGE_USERS,
  getParams: (payload) => payload,
})
